/**
 * Kiwi Sizing size-recommendation auto-select.
 * When Kiwi's recommender returns a size, click the matching size option
 * on the product form so the recommended size becomes the selected variant
 * (rather than leaving the default first-available size selected).
 */
(function () {
  function selectRecommendedSize(sizeValue) {
    if (!sizeValue) return;

    var normalizedTarget = String(sizeValue).trim().toLowerCase();
    var sizeFieldsets = document.querySelectorAll('fieldset.product-form__options--size');

    sizeFieldsets.forEach(function (fieldset) {
      var inputs = fieldset.querySelectorAll('input[data-variant-option]');

      inputs.forEach(function (input) {
        var inputValue = (input.value || '').trim().toLowerCase();

        if (inputValue !== normalizedTarget || input.checked) return;

        var label = fieldset.querySelector('label[for="' + input.id + '"]');

        if (label && !label.classList.contains('disabled')) {
          label.click();
        } else if (!input.disabled) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  function initKiwiAutoSelect() {
    if (typeof window.ks === 'undefined') {
      // Kiwi's loader snippet queues calls made before its script finishes
      // downloading, but window.ks itself needs to exist first.
      window.setTimeout(initKiwiAutoSelect, 300);
      return;
    }

    ks.on('on_size_recommendation', function (data) {
      if (data && data.status === 'has_size' && data.size) {
        selectRecommendedSize(data.size);
      }
    });
  }

  initKiwiAutoSelect();
})();
